module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-vanishing-cousins.a46872c5.jpg";